import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { ArrayHelper } from "@calaosoft/osapp-common/utils/helpers/arrayHelper";
import { ComponentBase } from "../../../../helpers/ComponentBase";
import { IAvatar } from "@calaosoft/osapp-common/dms/models/iavatar";
import { ISearchOptions } from "../../../../model/search/ISearchOptions";
import { Site } from "../../models/site";
import { SitesService } from "../../services/sites.service";

@Component({
	selector: "calao-sites-list",
	templateUrl: "./sites-list.component.html",
	styleUrls: ["./sites-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SitesListComponent extends ComponentBase {
	//#region PROPERTIES

	private maSites: Site[];
	public get sites(): Site[] {
		return this.maSites;
	}
	@Input() public set sites(paSites: Site[]) {
		if (!ArrayHelper.areArraysFromDatabaseEqual(paSites, this.maSites)) {
			this.maSites = paSites;
			this.filteredSites = paSites;
		}
	}

	@Input() public searchAttributes: string[] = ["name"];
	@Input() public showSearchBar: boolean = true;
	public filteredSites: Site[];

	/** Valeur recherchée dans l'input de recherche. */
	public searchValue: string;
	public searchOptions: ISearchOptions<Site> = {
		hasPreFillData: true,
		searchboxPlaceholder: "Rechercher..."
	};

	//#endregion

	//#region METHODS

	constructor(
		private isvcSites: SitesService,
		poChangeDetector: ChangeDetectorRef
	) {
		super(poChangeDetector);
	}

	public editSite(poSite: Site): void {
		this.isvcSites.routeToSite(poSite);
	}

	public onFilteredSitesChanged(paSites: Site[]): void {
		this.filteredSites = paSites;
		this.detectChanges();
	}

	public getSiteAvatar(poSite: Site): IAvatar {
		return SitesService.createSiteAvatar(poSite);
	}

	//#endregion
}
